import React from "react";
import { Header } from "../../../components";

const fv = (data, getMoneda, getDisplayValue) => {
  if (!data || !data.total) return "-";
  return `${getMoneda()}${getDisplayValue(data.total)}`;
};

const fp = (val, getMoneda, getDisplayValue) => {
  if (!val) return null;
  return `${getMoneda()}${getDisplayValue(val)}`;
};

export const VPHeader = ({
  vistaCompleta,
  setVistaCompleta,
  mostrar2025,
  setMostrar2025,
  showInDollars,
  setShowInDollars,
  verChileYPeru,
  setVerChileYPeru,
  verYTD,
  setVerYTD,
  filtroGrupo,
  setFiltroGrupo,
  pais,
  logo,
  anoSeleccionado,
  setAnoSeleccionado,
  aniosDisponibles,
  currentYear,
  getDesglose,
  getMoneda,
  getDisplayValue,
  getMonthName,
  currentMonthIndex,
  calcularPipeline,
  calcularPipelineFacturacion,
  onOpenChart,
}) => {
  const isCierres = vistaCompleta === "cierres";
  const mesAct3 = getMonthName(currentMonthIndex).slice(0, 3).toUpperCase();
  const proxName = currentMonthIndex < 11 ? getMonthName(currentMonthIndex + 1) : "";
  const mesProx3 = proxName ? proxName.slice(0, 3).toUpperCase() : null;

  // YTD según el año elegido: año pasado = año completo, año en curso = hasta hoy,
  // año futuro = aún sin transcurrir (0).
  const ytdEnd = anoSeleccionado > currentYear ? 0 : anoSeleccionado < currentYear ? 12 : currentMonthIndex + 1;

  // Resúmenes — YTD incluye mes actual (todo hasta la fecha)
  const ytdCierres = getDesglose(anoSeleccionado, 1, ytdEnd, "cierres");
  const ytdFact = getDesglose(anoSeleccionado, 1, ytdEnd, "facturacion");
  const mesActCierres = getDesglose(anoSeleccionado, currentMonthIndex + 1, currentMonthIndex + 1, "cierres");
  const mesActFact = getDesglose(anoSeleccionado, currentMonthIndex + 1, currentMonthIndex + 1, "facturacion");
  const proxCierres =
    currentMonthIndex < 11
      ? getDesglose(anoSeleccionado, currentMonthIndex + 2, currentMonthIndex + 2, "cierres")
      : null;
  const proxFact =
    currentMonthIndex < 11
      ? getDesglose(anoSeleccionado, currentMonthIndex + 2, currentMonthIndex + 2, "facturacion")
      : null;

  // Forecast = confirmado + pipeline ponderado (90%×0.75 + 75%×0.50)
  const fcstCierresAct = (mesActCierres?.total || 0) + calcularPipeline(currentMonthIndex);
  const fcstCierresProx =
    currentMonthIndex < 11 ? (proxCierres?.total || 0) + calcularPipeline(currentMonthIndex + 1) : 0;
  const fcstFactAct = (mesActFact?.total || 0) + calcularPipelineFacturacion(currentMonthIndex);
  const fcstFactProx =
    currentMonthIndex < 11 ? (proxFact?.total || 0) + calcularPipelineFacturacion(currentMonthIndex + 1) : 0;

  const lbl = { color: "#222" };
  const fcst = { color: "#c57b1a" };
  const sep = { color: "#bbb" };

  return (
    <Header
      logo={logo}
      leftContent={
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "auto 12px auto 12px minmax(15.5rem, auto) 12px auto",
            alignItems: "center",
            gap: "2px 14px",
            fontSize: "15px",
          }}
        >
          {/* Fila Cierres */}
          <strong style={{ color: "#0b4b1a" }}>Cierres</strong>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>YTD: </span>
            <span>{fv(ytdCierres, getMoneda, getDisplayValue)}</span>
          </span>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>{mesAct3}: </span>
            <span>{fv(mesActCierres, getMoneda, getDisplayValue)}</span>
            {fcstCierresAct > (mesActCierres?.total || 0) && (
              <span style={fcst}> | {fp(fcstCierresAct, getMoneda, getDisplayValue)}</span>
            )}
          </span>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>{mesProx3 ? `${mesProx3}: ` : "- "}</span>
            {proxCierres && proxCierres.total ? (
              <>
                <span>{fv(proxCierres, getMoneda, getDisplayValue)}</span>
                {fcstCierresProx > (proxCierres?.total || 0) && (
                  <span style={fcst}> | {fp(fcstCierresProx, getMoneda, getDisplayValue)}</span>
                )}
              </>
            ) : fcstCierresProx > 0 ? (
              <span style={fcst}>{fp(fcstCierresProx, getMoneda, getDisplayValue)}</span>
            ) : (
              <span>-</span>
            )}
          </span>
          {/* Fila Facturación */}
          <strong style={{ color: "#0c0c58" }}>Facturación</strong>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>YTD: </span>
            <span>{fv(ytdFact, getMoneda, getDisplayValue)}</span>
          </span>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>{mesAct3}: </span>
            <span>{fv(mesActFact, getMoneda, getDisplayValue)}</span>
            {fcstFactAct > (mesActFact?.total || 0) && (
              <span style={fcst}> | {fp(fcstFactAct, getMoneda, getDisplayValue)}</span>
            )}
          </span>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>{mesProx3 ? `${mesProx3}: ` : "- "}</span>
            {proxFact && proxFact.total ? (
              <>
                <span>{fv(proxFact, getMoneda, getDisplayValue)}</span>
                {fcstFactProx > (proxFact?.total || 0) && (
                  <span style={fcst}> | {fp(fcstFactProx, getMoneda, getDisplayValue)}</span>
                )}
              </>
            ) : fcstFactProx > 0 ? (
              <span style={fcst}>{fp(fcstFactProx, getMoneda, getDisplayValue)}</span>
            ) : (
              <span>-</span>
            )}
          </span>
        </div>
      }
    >
      {/* Toggle Cierres/Facturación */}
      <div className="vp-toggle">
        <span className={`vp-toggle-label ${isCierres ? "active" : ""}`}>Cierres</span>
        <div
          className={`vp-toggle-switch ${isCierres ? "cierres" : "facturacion"}`}
          onClick={() => setVistaCompleta(isCierres ? "facturacion" : "cierres")}
        >
          <div className="vp-toggle-knob" />
        </div>
        <span className={`vp-toggle-label ${!isCierres ? "active" : ""}`}>Facturación</span>
      </div>
      {/* Checkboxes agrupados 2x2 — texto a la izquierda, checkbox a la derecha */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "auto auto",
          columnGap: "14px",
          rowGap: "2px",
          alignItems: "center",
          fontSize: "14px",
        }}
      >
        <label style={{ display: "flex", alignItems: "center", gap: "6px", justifyContent: "flex-end" }}>
          Ver AA
          <input type="checkbox" checked={mostrar2025} onChange={(e) => setMostrar2025(e.target.checked)} />
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            justifyContent: "flex-end",
            opacity: showInDollars ? 1 : 0.5,
            cursor: showInDollars ? "pointer" : "not-allowed",
          }}
        >
          {pais === "Chile" ? "Sumar Perú" : "Sumar Chile"}
          <input
            type="checkbox"
            checked={verChileYPeru}
            onChange={(e) => setVerChileYPeru(e.target.checked)}
            disabled={!showInDollars}
          />
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: "6px", justifyContent: "flex-end" }}>
          Ver en dólares
          <input type="checkbox" checked={showInDollars} onChange={(e) => setShowInDollars(e.target.checked)} />
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            justifyContent: "flex-end",
            opacity: isCierres ? 0.5 : 1,
            cursor: isCierres ? "not-allowed" : "pointer",
          }}
        >
          Ver YTD
          <input
            type="checkbox"
            checked={verYTD && !isCierres}
            onChange={(e) => setVerYTD(e.target.checked)}
            disabled={isCierres}
          />
        </label>
      </div>
      {pais === "Perú" ? (
        // PERÚ: Año + grupo apilados (2 filas) a la izquierda; botón gráfico CUADRADO icon-only
        // a la derecha del todo (marginLeft:auto), alto = las 2 filas (alignItems:stretch → no
        // estira el header). Mismo alto de bloque que el original (2 filas).
        <div style={{ display: "flex", flexDirection: "row", alignItems: "stretch", gap: "8px", marginLeft: "auto" }}>
          {/* Año + grupo apilados. Ancho fijo (columna) para que no colapsen — ancho normal, como
              el selector de Año en Chile. Alto fijo por select → alto de columna determinístico (56px). */}
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", width: "100px" }}>
            <select
              value={anoSeleccionado}
              onChange={(e) => setAnoSeleccionado(Number(e.target.value))}
              style={{
                width: "100%",
                boxSizing: "border-box",
                height: "26px",
                padding: "2px 6px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              {(aniosDisponibles || [])
                .filter((a) => Number(a) >= 2025)
                .map((a) => (
                  <option key={a} value={a}>
                    {a}
                  </option>
                ))}
            </select>
            {/* Filtro de grupo Todos/Visiona/AdLab — mismo estilo/alto/ancho que Año. Solo Perú. */}
            <select
              value={filtroGrupo}
              onChange={(e) => setFiltroGrupo(e.target.value)}
              style={{
                width: "100%",
                boxSizing: "border-box",
                height: "26px",
                padding: "2px 6px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              <option value="">Todos</option>
              <option value="grupo:visiona">Visiona</option>
              <option value="grupo:adlab">AdLab</option>
            </select>
          </div>
          {/* Botón gráfico CUADRADO icon-only: width = height explícitos (= alto de las 2 filas). */}
          <button
            className="chart-btn"
            onClick={onOpenChart}
            title="Ver gráfico"
            style={{ padding: 0, justifyContent: "center", width: "56px", height: "56px", flex: "none" }}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              style={{ width: 26, height: 26 }}
            >
              <rect x="3" y="12" width="4" height="9" rx="1" />
              <rect x="10" y="7" width="4" height="14" rx="1" />
              <rect x="17" y="3" width="4" height="18" rx="1" />
            </svg>
          </button>
        </div>
      ) : (
        // CHILE (y otros): layout original intacto — Año apilado sobre el botón Gráficos (con palabra).
        <div style={{ display: "flex", flexDirection: "column", alignItems: "stretch", gap: "4px" }}>
          <select
            value={anoSeleccionado}
            onChange={(e) => setAnoSeleccionado(Number(e.target.value))}
            style={{
              width: "100%",
              padding: "2px 6px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              fontSize: "13px",
              cursor: "pointer",
            }}
          >
            {(aniosDisponibles || [])
              .filter((a) => Number(a) >= 2025)
              .map((a) => (
                <option key={a} value={a}>
                  {a}
                </option>
              ))}
          </select>
          <button className="chart-btn" onClick={onOpenChart} title="Ver gráfico">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <rect x="3" y="12" width="4" height="9" rx="1" />
              <rect x="10" y="7" width="4" height="14" rx="1" />
              <rect x="17" y="3" width="4" height="18" rx="1" />
            </svg>
            Gráficos
          </button>
        </div>
      )}
    </Header>
  );
};
